@if (flyoutMenuUserData()) {
  <a role="button"
     tabindex="0"
     class="td-wb-top-navigation__link"
     [class.td-wb-top-navigation__menu--open]="isFlyoutMenuOpened()"
     [tdWbFlyoutMenuToggle]="flyoutMenuUserData()"
     [tdWbFlyoutMenuTogglePositionStrategy]="positionStrategy()"
     [tdWbFlyoutMenuToggleGlobalPosition]="globalPosition()"
     [tdWbFlyoutMenuToggleOverlayPosition]="[overlayPosition()]">
    <ng-container *ngTemplateOutlet="customLabel() ? customLabelTemplate : regularLabelTemplate" />
    <td-wb-icon size="12"
                iconId="caret--down"
                class="td-wb-icon--caret--down"
                [inline]="true" />
  </a>
}
<ng-content />

<ng-template #regularLabelTemplate>
  <span [innerText]="item().text"></span>
</ng-template>

<ng-template #customLabelTemplate>
  <ng-content select="td-wb-top-navigation-item-label" />
</ng-template>
